<template>
  <div class="home-page">
    <MonitorForm></MonitorForm>
  </div>
</template>

<script>
import API from "../api"
import MonitorForm from "../components/MonitorForm.vue"

export default {
  name: 'new-monitor-page',
  data () {
    return {
        loading: false,
    }
  },
  components: {
    MonitorForm
  },
  watch: {
      // '$route': 'fetchLatestChecks'
  },
  created() {
  },
  methods: {}
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/NewMonitorPage.vue